import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Terima kasih! Pesan Anda telah terkirim. Tim kami akan segera menghubungi Anda.');
    setFormData({
      name: '',
      phone: '',
      email: '',
      subject: '',
      message: ''
    });
  };

  const socialMedia = [
    { icon: 'fa-instagram', name: '@pakmoo_official' },
    { icon: 'fa-facebook', name: 'PAK MoO' },
    { icon: 'fa-youtube', name: 'PAK MoO Channel' },
    { icon: 'fa-tiktok', name: '@pakmoo' }
  ];

  return (
    <section id="kontak" className="pt-20 sm:pt-24 pb-16 sm:pb-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center bg-primary/10 text-primary px-3 py-2 rounded-full text-xs sm:text-sm font-medium mb-3 sm:mb-4">
            <i className="fa-solid fa-phone mr-2"></i>
            Hubungi Kami
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-4 sm:mb-6">
            Mari Berkolaborasi<br className="hidden sm:block"/>
            <span className="text-secondary">Untuk Masa Depan</span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-2">
            Tim kami siap membantu Anda. Hubungi kami melalui berbagai channel 
            komunikasi yang tersedia untuk konsultasi dan pemesanan.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16">
          <div className="space-y-6 sm:space-y-8">
            <div className="bg-light-bg rounded-2xl p-6 sm:p-8">
              <h3 className="text-xl sm:text-2xl font-bold text-primary mb-4 sm:mb-6">Informasi Kontak</h3>
              <div className="space-y-5 sm:space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="fa-solid fa-map-marker-alt"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-primary mb-1 sm:mb-2 text-sm sm:text-base">Alamat Kantor</h4>
                    <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                      Jl. Raya Pertanian No. 123<br/>
                      Bogor, Jawa Barat 16610<br/>
                      Indonesia
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-secondary text-white rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="fa-solid fa-phone"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-primary mb-1 sm:mb-2 text-sm sm:text-base">Telepon & WhatsApp</h4>
                    <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                      +62 812-3456-7890<br/>
                      +62 21-8765-4321
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-accent text-primary rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="fa-solid fa-envelope"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-primary mb-1 sm:mb-2 text-sm sm:text-base">Email</h4>
                    <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                      info@pakmoo.co.id<br/>
                      cs@pakmoo.co.id
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="fa-solid fa-clock"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-primary mb-1 sm:mb-2 text-sm sm:text-base">Jam Operasional</h4>
                    <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                      Senin - Jumat: 08:00 - 17:00 WIB<br/>
                      Sabtu: 08:00 - 15:00 WIB<br/>
                      Minggu: Tutup
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-primary rounded-2xl p-6 sm:p-8 text-white">
              <h3 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6">Media Sosial</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                {socialMedia.map((social, index) => (
                  <span key={index} className="flex items-center bg-white/10 rounded-xl p-3 sm:p-4 hover:bg-white/20 transition-colors cursor-pointer">
                    <i className={`fa-brands ${social.icon} text-xl sm:text-2xl mr-3`}></i>
                    <span className="text-sm sm:text-base">{social.name}</span>
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="bg-light-bg rounded-2xl p-6 sm:p-8">
            <h3 className="text-xl sm:text-2xl font-bold text-primary mb-4 sm:mb-6">Kirim Pesan</h3>
            <form onSubmit={handleSubmit} className="space-y-5 sm:space-y-6">
              <div className="grid md:grid-cols-2 gap-4 sm:gap-6">
                <div>
                  <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">Nama Lengkap</label>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" 
                    placeholder="Masukkan nama lengkap"
                    required
                  />
                </div>
                <div>
                  <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">Nomor Telepon</label>
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" 
                    placeholder="Masukkan nomor telepon"
                    required
                  />
                </div>
              </div>
              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">Email</label>
                <input 
                  type="email" 
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" 
                  placeholder="Masukkan alamat email"
                  required
                />
              </div>
              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">Subjek</label>
                <select 
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                  required
                >
                  <option value="">Pilih subjek pesan</option>
                  <option value="qurban">Pemesanan Hewan Qurban</option>
                  <option value="organik">Konsultasi Produk Organik</option>
                  <option value="kemitraan">Kemitraan Usaha</option>
                  <option value="keluhan">Keluhan & Saran</option>
                  <option value="lainnya">Lainnya</option>
                </select>
              </div>
              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">Pesan</label>
                <textarea 
                  rows="6" 
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none" 
                  placeholder="Tuliskan pesan Anda..."
                  required
                ></textarea>
              </div>
              <button type="submit" className="w-full bg-accent text-primary py-3 sm:py-4 rounded-xl font-semibold text-base sm:text-lg hover:bg-yellow-400 transition-colors">
                <i className="fa-solid fa-paper-plane mr-2"></i>
                Kirim Pesan
              </button>
            </form>
          </div>
        </div>

        <div className="mt-12 sm:mt-16 bg-gradient-to-r from-secondary to-primary rounded-3xl p-6 sm:p-8 text-white text-center">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-0 sm:mb-6 mb-4">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-white/20 rounded-full flex items-center justify-center sm:mr-4">
              <i className="fa-brands fa-whatsapp text-2xl sm:text-3xl"></i>
            </div>
            <div className="text-center sm:text-left">
              <h3 className="text-xl sm:text-2xl font-bold">Chat Langsung dengan Tim Kami</h3>
              <p className="text-gray-200 text-sm sm:text-base">Respon cepat dalam hitungan menit</p>
            </div>
          </div>
          <button className="bg-green-500 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold text-base sm:text-lg hover:bg-green-600 transition-colors">
            <i className="fa-brands fa-whatsapp mr-2"></i>
            Chat WhatsApp Sekarang
          </button>
        </div>
      </div>
    </section>
  );
};

export default Contact;

